import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { block } from 'bem-cn';

import DaysFilter from 'features/myStatistics/DaysFilter';

import Button from 'components/Button';
import InputDate from 'components/InputDate';

import './Filters.scss';

const b = block('statistic-filters-mobile');

const Filters = ({ model }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  return (
    <form className={b()} onSubmit={model.outputState.onSubmit}>
      <DaysFilter
        activeDay={model.outputState.activeDaySelect}
        setActiveDay={model.inputState.setActiveDay}
        isMobile
      />

      <div className={b('content')}>
        <div className={b('item')}>
          <div className={b('item-label')}>{locale.from}</div>
          <div className={b('item-field')}>
            <InputDate
              dateFormat="DD.MM.YYYY"
              value={model.inputState.values.from}
              onChange={model.inputState.onChangeFrom}
              deleteWord=''
            />
          </div>
        </div>

        <div className={b('item')}>
          <div className={b('item-label')}>{locale.to}</div>
          <div className={b('item-field')}>
            <InputDate
              dateFormat="DD.MM.YYYY"
              value={model.inputState.values.to}
              onChange={model.inputState.onChangeTo}
              deleteWord=''
            />
          </div>
        </div>

        <div className={b('button')}>
          <Button type="submit" text={locale.acceptFilter} />
        </div>
      </div>
    </form>
  );
};

export default Filters;
